import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ShopCategoryFormLayer from "../components/ShopCategoryFormLayer";

const ShopCategoryFormPage = () => {
    return (
        <>
            <MasterLayout>
                <ShopCategoryFormLayer />
            </MasterLayout>
        </>
    );
};

export default ShopCategoryFormPage;
